module.exports = __webpack_public_path__ + "static/img/Medical Care.b3e27f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applications/Medical Care.jpg
// module id = ZdFW
// module chunks = 1